import type { ReactNode } from 'react';
import { IS_DEMO, IS_LOCKED } from '../../apiBase';

// EVERYTHING INSIDE THIS IS DEAD IN A BUILD THAT MAY NOT PRESS, and alive everywhere else.
//
// TWO OF THEM NOW: the demo, and the sandbox. Both refuse to spend at the outbound edge, so a
// run button on either reaches the server and comes back refused — see IS_LOCKED, which is
// that one fact and not the rest of what being the demo means.
//
// A <fieldset disabled> and not a `disabled` prop threaded through every button: the
// browser's own rule is that a disabled fieldset disables every control inside it,
// however deeply nested and however many components down. So a run button added to a
// phase next month is locked by where it sits rather than by somebody remembering.
//
// `display: contents` because the fieldset must not be a box. Wrapping a flex row in a
// real element would put the buttons inside a child of the row instead of in the row,
// and the layout would change in prod, where nothing about this is meant to show at
// all. With `contents` the fieldset generates no box and its children stay exactly
// where they were.
//
// It only ever DISABLES. There is no un-lock: a disabled fieldset cannot be undone by
// a nested one, which is the behaviour we want — the lock cannot be defeated by
// accident from inside. Anything the demo must keep working (the run pager, the phase
// navigation) is placed OUTSIDE the lock rather than exempted within it.
export function DemoLock({ children, className = '' }: { children: ReactNode; className?: string }) {
  if (!IS_LOCKED) return <>{children}</>;
  return (
    <fieldset
      disabled
      className={`contents ${className}`}
      // A disabled control swallows pointer events in most browsers, so this title is
      // read from the gaps rather than from the buttons. It is the only explanation
      // offered: the demo does not announce itself, and a page of dead buttons under a
      // banner reading "read-only copy" was the banner telling somebody what they could
      // already see.
      title={IS_DEMO ? 'Turned off in the demo' : 'Turned off in the sandbox'}
    >
      {children}
    </fieldset>
  );
}
